import { Target, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { userTZ } from "@/lib/format";

export default function AppHeader({ subtitle }) {
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src="/logo.png?v=3" alt="Health Coach Marathon" className="h-10 w-10 rounded-lg object-contain bg-white border border-border" />
          <div>
            <div className="font-display font-extrabold leading-none">Health Coach Marathon</div>
            <div className="text-xs text-muted-foreground">{subtitle}</div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="text-right hidden sm:block">
            <div className="text-sm font-medium leading-none">{user?.name || user?.email}</div>
            <div className="text-xs text-muted-foreground mt-0.5">{userTZ}</div>
          </div>
          <div className="h-9 w-9 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center font-display font-bold">
            {(user?.name || user?.email || "?").slice(0, 1).toUpperCase()}
          </div>
          <Button variant="ghost" size="icon" onClick={logout} data-testid="logout-btn" title="Log out">
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
